import type { Optional } from '@festina-life/core'
import type { FPlusLiteralType } from '@festina-life/fplus-monaco'

export const expressionItemClassName: Record<
  FPlusLiteralType,
  Optional<string>
> = {
  string:
    'italic text-monaco-codeString dark:text-monaco-codeStringDark text-wrap break-all">',
  boolean: 'text-monaco-codeExpression dark:text-monaco-codeExpressionDark',
  enum: 'text-monaco-codeEnum dark:text-monaco-codeEnumDark',
  fraction: 'text-monaco-codeNumber dark:text-monaco-codeNumber',
  integer: 'text-monaco-codeNumber dark:text-monaco-codeNumber',
  null: 'text-monaco-codeExpression dark:text-monaco-codeExpressionDark',
  blank: undefined,
}
